import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  email: string;
}

export function ResendInvitationSuccessToast(props: Props) {
  const {
    id, email,
  } = props

  const polyglot = usePolyglot()

  return (
    <Toast
      stylePreset="success"
      body={polyglot.t(
        "toasts.follow_invitation_resend_success.body",
        { email },
      )}
      id={id}
    />
  )
}